import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { peekPendingAction, clearPendingAction, runPendingAction } from '../utils/pendingAction';

const DONE_TEXT = {
  like_post: ['Liked the post ❤️', 'Te gustó la publicación ❤️'],
  like_activity: ['Liked the post ❤️', 'Te gustó la publicación ❤️'],
  comment_post: ['Your comment was posted', 'Tu comentario fue publicado'],
  comment_activity: ['Your comment was posted', 'Tu comentario fue publicado'],
  follow_user: ['You are now following them', 'Ahora lo sigues'],
};

/** After sign-in, finish the like/follow/comment the guest started and return them to that spot. */
const PendingActionRunner = () => {
  const { user } = useAuth();
  const { language } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const running = useRef(false);

  useEffect(() => {
    if (!user || running.current) return;
    const action = peekPendingAction();
    if (!action) return;
    running.current = true;
    clearPendingAction();
    (async () => {
      const ok = await runPendingAction(action);
      const [en, es] = DONE_TEXT[action.type] || ['Done', 'Listo'];
      if (ok) toast.success(language === 'es' ? es : en);
      if (action.target) sessionStorage.setItem('lumera_scroll_to', action.target);
      if (action.returnTo && location.pathname + location.search !== action.returnTo) {
        navigate(action.returnTo, { replace: true });
      } else {
        window.dispatchEvent(new CustomEvent('lumera:pending-action-done', { detail: action }));
      }
      running.current = false;
    })();
  }, [user, language, navigate, location]);

  return null;
};

export default PendingActionRunner;
